<template>
  <LinkCard
    :search-result="searchResult"
    :result-position="resultPosition"
    :destination-url="resolvedUrl"
    :opens-in-new-tab="!!searchResult.opens_in_new_tab"
    @result-clicked="$emit('result-clicked', $event)"
  />
</template>

<script setup>
import LinkCard from './LinkCard.vue';
import { computed } from 'vue';
import { useMainStore } from '../../../stores/mainStore.js';

const props = defineProps({
  searchResult: {
    type: Object,
    default: () => ({}),
  },
  resultPosition: {
    type: Number,
    required: true,
  },
});

defineEmits(['result-clicked']);

const mainStore = useMainStore();

/**
 * Resolves the destination for a custom menu item result.
 * Custom menu items expose their destination as a top level `url` instead of `content.url`.
 * Site relative urls are resolved against the organization that owns the result, so results from
 * other schools keep pointing at their own site, and fall back to the current site when the
 * result has no `link`.
 * @returns {string} The url to navigate to, or an empty string when the result has no url.
 */
const resolvedUrl = computed(() => {
  const rawUrl = props.searchResult.url || '';
  const isSiteRelative = rawUrl.startsWith('/') && !rawUrl.startsWith('//');
  if (!isSiteRelative) return rawUrl;

  const orgBaseUrl = props.searchResult.link || mainStore.pathPrefix;
  return `${orgBaseUrl}${rawUrl}`;
});
</script>
